import React, { Component } from 'react';

import Uuid from '../../../../../support/Uuid';
import CartaPorteMercanciaCantidadTransportaForm from './CartaPorteMercanciaCantidadTransportaForm';
import CartaPorteMercanciaCantidadTransportaList from './CartaPorteMercanciaCantidadTransportaList';

class CartaPorteMercanciaCantidadTransportaManager extends Component {
  state = {}

  handleOnAdd = (data) => {
    const { CantidadTransporta = [] } = this.props.data;

    const newData = CantidadTransporta.concat([{
      id: Uuid.v4(),
      ...data
    }]);

    this.handleOnListChange(newData);
  }

  handleOnListChange = (data) => {
    const newData = {
      CantidadTransporta: data
    }

    this.props.onChange(newData);
  }

  handleOnEdit = (item) => {
    this.setState({
      data: { ...item }
    }, () => {
      this.setState({
        data: undefined
      });
    });
  }

  render() {
    const { data } = this.state;
    const { CantidadTransporta =  [] } = this.props.data;

    return (
      <>
        <fieldset>
          <legend>Cantidad Transporta</legend>

          <CartaPorteMercanciaCantidadTransportaForm
            data={ data }
            onAdd={ this.handleOnAdd }
          />

          <CartaPorteMercanciaCantidadTransportaList
            data={ CantidadTransporta }
            onEdit={ this.handleOnEdit }
            onChange={ this.handleOnListChange }
          />
        </fieldset>
      </>
    )
  }
}

export default CartaPorteMercanciaCantidadTransportaManager;